import styles from './SegmentedControl.module.css'

interface SegOption {
  value: string
  label: string
}

interface SegmentedControlProps {
  name: string
  value: string
  options: SegOption[]
  onChange: (value: string) => void
  fullWidth?: boolean
}

export function SegmentedControl({ name, value, options, onChange, fullWidth }: SegmentedControlProps) {
  return (
    <div className={`${styles.seg}${fullWidth ? ` ${styles['seg-full']}` : ''}`}>
      {options.map((opt) => (
        <label key={opt.value} className={styles['seg-opt']}>
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
          />
          <span>{opt.label}</span>
        </label>
      ))}
    </div>
  )
}
